import { Link } from 'react-router-dom';
import { getFeaturedArticles, type Article } from '@/mocks/articles';

function formatViews(views: number): string {
  if (views >= 10000) return `${(views / 10000).toFixed(1)}万`;
  return views.toString();
}

function FeaturedCard({ article }: { article: Article }) {
  return (
    <Link
      to={`/article/${article.id}`}
      className="group relative bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden hover:-translate-y-1 transition-all duration-300"
    >
      <div className="relative aspect-video overflow-hidden">
        <img
          src={article.thumbnail}
          alt={article.title}
          title={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
        <div className="absolute bottom-3 right-3 bg-black/70 backdrop-blur-sm text-white text-xs px-2 py-0.5 rounded-md">
          {article.duration}
        </div>
        <div className="absolute top-3 left-3">
          <span className="bg-primary-500 text-white text-xs px-2.5 py-1 rounded-full font-medium">
            热门
          </span>
        </div>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center">
            <i className="ri-play-fill text-white text-2xl ml-0.5"></i>
          </div>
        </div>
      </div>
      <div className="p-4 md:p-5">
        <h3 className="font-heading text-foreground-900 text-sm md:text-base mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors duration-200">
          {article.title}
        </h3>
        <p className="text-foreground-500 text-xs md:text-sm line-clamp-2 mb-3">{article.description}</p>
        <div className="flex items-center justify-between text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-eye-line"></i>
            </span>
            {formatViews(article.views)}
          </span>
          <span className="flex items-center gap-1">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-thumb-up-line"></i>
            </span>
            {formatViews(article.likes)}
          </span>
          <span>{article.date}</span>
        </div>
      </div>
    </Link>
  );
}

export default function FeaturedSection() {
  const featured = getFeaturedArticles();

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">
              热门推荐
            </h2>
            <p className="text-foreground-600 text-sm">精选优质内容，不容错过</p>
          </div>
          <Link
            to="/category/entertainment"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap"
          >
            查看更多
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featured.map((article) => (
            <FeaturedCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}